$(function () {

	var mainContainer = $('.js-page'),
		openCtrl = $('.js-open-search'),
		closeCtrl = $('#btn-search-close'),
		searchContainer = $('.search'),
		inputSearch = $('.search__input');

	function init() {
		initEvents();
	}


	function initEvents() {
		openCtrl.click(openSearch);
		closeCtrl.click(closeSearch);
	}

	$('body').keyup(function (ev) {
		if (ev.keyCode == 27 && $('body').hasClass('show-search')) {
			closeSearch();
		}
	})

	function openSearch(e) {

		$('html').addClass('show-search');

		if (isWidth(_scrollInitWidth, false)) {
			$('body').getNiceScroll().remove();
		}

		mainContainer.addClass('main-wrap--move');
		searchContainer.addClass('search--open');
		$('.header').css('top', searchContainer.outerHeight());
		inputSearch.focus();

		e.preventDefault();
	}

	function closeSearch() {
		$('html').removeClass('show-search');
		mainContainer.removeClass('main-wrap--move');
		searchContainer.removeClass('search--open');
		$('.header').attr('style', '');
		$('body').removeClass('_height');
		setTimeout(function () {
			initScroll();
		}, 500);
		inputSearch.blur();
		inputSearch.value = '';
	}

	init();

});
